<template>
  <div class="funnel canvas-funnel-container">
    <canvas ref="funnelCanvas" width="1280" height="1200"></canvas>
  </div>
</template>
<style>
  .funnel.canvas-funnel-container {
    margin: 0.5rem auto;
    /*box-shadow: 0 0 4px rgba(0,0,0, 0.1), 0 0 2px rgba(0,0,0, 0.1) inset;*/
    max-width: 100%;
    width: 480px !important;
  }
  .funnel.canvas-funnel-container canvas {
    max-width: 100%;
  }
</style>
<script>
  export default {
    name: 'Funnel',
    components: {},
    props: {
      segments: {
        type: Array,
        required: true
      },
      inputValue: {
        type: Number,
        required: true
      },
      inputPrefix: {
        type: String,
        required: false
      },
      inputSuffix: {
        type: String,
        required: false
      },
      inputSubtitle: {
        type: String,
        required: false,
      },
      showCalculatedPercentages: {
        type: Boolean,
        default: true,
      },
      skipZeroRatios: {
        type: Boolean,
        default: true,
      },
      scaling: {
        type: String,
        default: "linear",
      }
    },
    data: function () {
      return {
        canvas: null,
        ctx: null,
      }
    },
    watch: {
      segments: function (newVal, oldVal) {
        this.redraw();
      },
      inputValue: function (newVal, oldVal) {
        this.redraw();
      }
    },
    computed: {
      computedValue: function() {
        const segments = this.segmentsComputed;
        return segments[segments.length - 1].computedValue;
      },
      segmentsComputed: function () {
        let ratio = 1;
        let value = this.inputValue;

        const ret = [{compositeRatio: ratio, computedValue: value, suffix: this.inputSuffix, prefix: this.inputPrefix}];
        for(let segment of this.segments) {
          if(typeof segment.ratio !== "number" || segment.ratio < 0) {
            console.warn("Funnel.vue: segments must include 'ratio' (positive or zero)", segment.ratio);
          }else if(segment.ratio > 0 || !this.skipZeroRatios) {
            ratio *= segment.ratio;
            value *= segment.ratio;
            ret.push(Object.assign({compositeRatio: ratio, computedValue: value}, segment));
          }
        }
        let largestRatio = ret.length ? ret[0].compositeRatio : 0;
        for(let seg of ret) {
          if(largestRatio < seg.compositeRatio) {
            largestRatio = seg.compositeRatio;
          }
        }
        const ratioOvershootScalar = 1 / Math.max(1, largestRatio);
        for(let k in ret) {
          if(!ret.hasOwnProperty(k))
            continue;
          let r = ret[k].compositeRatio;
          switch (this.scaling) {
            case 'linear':
              r = r * ratioOvershootScalar;
              break;
            case 'quadratic':
              r = Math.pow(r * ratioOvershootScalar, 1/1.41);
              break;
            case 'flattened':
              r = (Math.pow(r * ratioOvershootScalar, 1/3) + 0.4) / 1.4;
              break;
            case 'flattened-hard':
              r = (Math.pow(r * ratioOvershootScalar, 1/8) + 3) / 4;
              break;
            case 'constant-large':
              r = 1;
              break;
            case 'constant-small':
              r = 0.55;
              break;
            default: console.warn("Funnel.vue: scaling can only be of: 'linear', 'flattened', 'constant-large', 'constant-small'"); // todo
          }
          ret[k].renderRatio = r;
        }
        return ret;
      }
    },
    methods: {
      setupContext: function () {
        const canvas = this.canvas = this.$refs.funnelCanvas;
        const ctx = this.ctx = canvas.getContext('2d');
        console.log("FUNNEL!", this.inputValue, this.sections)
      },
      drawCenteredText: function (str, size, x, y, fontWeight, bg) {
        const ctx = this.ctx;
        if(!fontWeight) fontWeight = 800;
        ctx.font = parseInt(fontWeight) + " " + parseFloat(size) + 'px averta, sans-serif';
        ctx.textBaseline = 'middle';
        const m = ctx.measureText(str);
        console.log(str, m);
        const oldFill = ctx.fillStyle;
        if(bg) {
          ctx.fillStyle = bg;
          ctx.fillRect(x - m.width/2 - 6, y-size/2 - 1, m.width + 12, size);
          ctx.fillStyle = oldFill;
        }
        ctx.fillText(str, x - m.width/2, y);
      },
      drawSegment: function (totalSegments, idx, seg, previousSeg) {
        const ctx = this.ctx;

        const segmentHeight = 105;
        const intervalHeight = 170;
        const outlineWidth = 7;
        const gap = 32;
        const baseW = ctx.canvas.width - outlineWidth*2; // width of 100% segment

        const topY = idx * (segmentHeight + intervalHeight + gap * 2) - intervalHeight - gap * 2 + outlineWidth;
        const midX = ctx.canvas.width / 2;

        const topW = previousSeg ? previousSeg.renderRatio * baseW : null;
        const bottomW = seg.renderRatio * baseW;

        ctx.strokeStyle = '#510035';
        ctx.fillStyle = '#c80046';
        ctx.lineWidth = outlineWidth;
        ctx.beginPath();
        ctx.rect(midX - bottomW/2, topY + intervalHeight + gap*2, bottomW, segmentHeight);
        ctx.stroke();
        ctx.fill();

        // block
        const fontSize = 58;
        ctx.fillStyle = 'white';
        const showInputSubtitle = (!previousSeg && this.inputSubtitle !== undefined);
        const showSubtitle = this.showCalculatedPercentages || showInputSubtitle;
        const valueOffset = showSubtitle ? -fontSize * 0.39 : 0;

        // block value text
        const prefix = seg.prefix ? seg.prefix : '';
        const suffix = seg.suffix ? seg.suffix : '';
        this.drawCenteredText(prefix+Math.round(seg.computedValue)+suffix, fontSize * 0.75, midX, topY + intervalHeight + gap*2 + segmentHeight/2 + 4 + valueOffset, null, '#c80046');

        // block subtitle text
        if(showSubtitle) {
          const subtitle = showInputSubtitle ? this.inputSubtitle : Math.round(seg.compositeRatio*1000)/10+'%';
          this.drawCenteredText(subtitle, fontSize * 0.5, midX, topY + intervalHeight + gap*2 + segmentHeight/2 + 5 - valueOffset, 600, '#c80046');
        }

        // funnel-part

        if(topW === null)  // don't draw funnel-part for first block
          return;

        // funnel lines
        ctx.strokeStyle = '#75bc7f'; //'#c0e3de';
        ctx.lineWidth = 12;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(midX - topW/2.1, topY + gap);
        ctx.lineTo(midX - bottomW/2.05, topY + gap + intervalHeight);
        ctx.moveTo(midX + topW/2.1, topY + gap);
        ctx.lineTo(midX + bottomW/2.05, topY + gap + intervalHeight);
        ctx.stroke();

        // funnel value
        ctx.fillStyle = '#c80046';
        const labelOffset = seg.label ? -fontSize * 0.55 : 0;
        const label = seg.ratioStringOverride ? seg.ratioStringOverride : Math.round(seg.ratio*1000)/10+'%';
        this.drawCenteredText(label, fontSize, midX, topY + intervalHeight/2 + gap - labelOffset - fontSize/4);

        // funnel label (above funnel value)
        if(seg.label) {
          ctx.fillStyle = '#7c0435';
          this.drawCenteredText(seg.label, fontSize * 0.7, midX, topY + intervalHeight / 2 + gap + labelOffset - fontSize/4, 600);
        }

      },
      redraw: function () {
        const ctx = this.ctx;
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.restore();

        const totalSegments = this.segmentsComputed.length;
        let idx = 0;
        let previousSeg = null;
        for(let seg of this.segmentsComputed) {
          this.drawSegment(totalSegments, idx++, seg, previousSeg);
          previousSeg = seg;
        }
      }
    },
    mounted: function () {
      this.setupContext();
      this.redraw();
    }
  }
</script>
